export var AuthType;
(function (AuthType) {
    AuthType["qualifiedAuth"] = "qualifiedAuth";
    AuthType["smsAuth"] = "smsAuth";
    AuthType["emailAuth"] = "emailAuth";
})(AuthType || (AuthType = {}));
export const getAuthType = (signatureType, additionalAuthenticationType) => {
    if (signatureType === 'QUALIFIED') {
        return AuthType.qualifiedAuth;
    }
    if (additionalAuthenticationType === 'SMS_DEFAULT') {
        return AuthType.smsAuth;
    }
    if (additionalAuthenticationType === 'NONE') {
        return AuthType.emailAuth;
    }
    return AuthType.emailAuth;
};
export const OrganizationUserRole = {
    user: {
        id: 'USER',
        level: 0,
        messageId: 'userRole',
    },
    admin: {
        id: 'ADMIN',
        level: 1,
        messageId: 'adminRole',
    },
    superAdmin: {
        id: 'SUPER_ADMIN',
        level: 2,
        messageId: 'superAdminRole',
    },
};
export const OrganizationUserRoleById = {
    USER: OrganizationUserRole.user,
    ADMIN: OrganizationUserRole.admin,
    SUPER_ADMIN: OrganizationUserRole.superAdmin,
};
export const isRoleLevelMet = (targetRole, userRoleId) => {
    const userRole = OrganizationUserRoleById[userRoleId];
    return userRole && userRole.level >= OrganizationUserRole[targetRole].level;
};
export const checkMemberPermission = (tags, permissionLevel, planName) => {
    if (planName === 'Plan Pro') {
        for (let index = 0; index < tags.length; index++) {
            const element = tags[index];
            if (element.permissions &&
                element.permissions.includes(permissionLevel)) {
                return true;
            }
            else {
                for (let id = 0; id < tags.length; id++) {
                    const role = element.roles
                        ? element.roles[id]
                        : element.defaultRoles[id];
                    if (role &&
                        role.hasOwnProperty('permissions') &&
                        role.permissions.includes(permissionLevel)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    return false;
};
